import { render, staticRenderFns } from "./test-builder-edit.vue?vue&type=template&id=27d6cbc4&"
import script from "./test-builder-edit.vue?vue&type=script&lang=js&"
export * from "./test-builder-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports